import { getEmbedConfigurationValueOrDefault } from 'modules/embed/selectors'
import { getIsInitComplete } from 'modules/view/selectors'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { log } from 'utils'
import { initI18n } from 'utils/i18n'

const useInitializeI18n = () => {
  const [i18nInitialized, setI18nInitialized] = useState(false)

  const isInitComplete = useSelector(getIsInitComplete)
  const embedLocale = useSelector(state => getEmbedConfigurationValueOrDefault(state, 'locale'))

  useEffect(() => {
    if (isInitComplete && !i18nInitialized) {
      const runAsync = async () => {
        try {
          await initI18n(embedLocale)
        } catch (err) {
          log({ data: [`i18n failed to load - ${err.message}`, err], type: 'warn' })
        }
        setI18nInitialized(true)
      }
      runAsync()
    }
  }, [isInitComplete, i18nInitialized, embedLocale])

  return i18nInitialized && isInitComplete
}

export default useInitializeI18n
